export default (state = [], action) => {
	switch (action.type) {
		case "ADD_FULFILLMENT_SERVICE":
			var newState = state.slice();
			newState.push(action.fulfillmentService);
			return newState;
		default:
			return state;
	}
};
